/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit No/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function No({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentCard/Images/ActiveTab/Images/Content/Content/Content/Preview/No"
  
}) {
  return (<React.Fragment
>
<div
  data-testid="No.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
/>
{children}
</React.Fragment>)
}